'use client';
var requestMethods = [
    "get",
    "post",
    "put",
    "patch",
    "head",
    "delete"
];
var responseTypes = {
    json: "application/json",
    text: "text/*",
    formData: "multipart/form-data",
    arrayBuffer: "*/*",
    blob: "*/*"
};
// Максимальное значение 32-битного целочисленного типа -- совместимость с node
var maxSafeTimeout = 2147483647;

export { maxSafeTimeout, requestMethods, responseTypes };
